const ResetModal = function () {
  this.addPermission.hideModal()
  this.addPermission.resetForm()
}

export default ResetModal
